import React, { useRef } from 'react'
import { Divider, Dropdown, Flex, Space, Typography } from 'antd'
import { useIntl } from 'react-intl'
import Button from '../../common/Button'
import Mappings from './Mappings'
import { formatDateTime } from '../../../utils/common'

const ExpandedRowRender = ({ record, index, onAccept }) => {
  const intl = useIntl()
  const dtcReviewLogsDropDownRef = useRef(null)
  const handleLogsOpen = (open) => {
    if (open) {
      requestAnimationFrame(() => {
        dtcReviewLogsDropDownRef.current?.scrollTo({ top: 0 })
      })
    }
  }

  return (
    <div className="dtc-review-expanded">
      <Flex justify='space-between' gap={16} className="review-heading">
        <Space size={'middle'}>
          <Typography.Text level={5} className="bold" style={{ margin: 0 }}>
            {intl.formatMessage({ id: 'dtcs.mappings.tracerAuthoringMapping' })}
          </Typography.Text>

          {record.destination_only && (
            <Typography.Text className="bold">
              {intl.formatMessage({ id: 'dtcs.mappings.destinationOnly' })}
            </Typography.Text>
          )}
        </Space>

        {
          <Typography.Text className="bold">
            [
            {record?.at_mapping?.end[0]?.updated_at
              ? formatDateTime(record?.at_mapping?.end[0]?.updated_at)
              : ''}
            ]
          </Typography.Text>
        }
      </Flex>

      <Flex justify='space-between' gap={16} className="review-heading">
        <Space size={'middle'}>
          <Typography.Text level={5} className="bold" style={{ margin: 0 }}>
            {intl.formatMessage({ id: 'dtcs.mappings.crowdSourcedMapping' })}
          </Typography.Text>

          {record?.updated_by && (
            <Typography.Text className="bold">
              ({record.updated_by})
            </Typography.Text>
          )}

          {record.tracer_destination_only && (
            <Typography.Text className="bold">
              {intl.formatMessage({ id: 'dtcs.mappings.destinationOnly' })}
            </Typography.Text>
          )}
        </Space>

        {record.logs ? (
          <Dropdown
            trigger={['click']}
            // placement="bottom"
            onOpenChange={(open) => handleLogsOpen(open)}
            popupRender={() => (
              <div
                ref={dtcReviewLogsDropDownRef}
                className="ant-dropdown-menu dtc-mapping-review-logs"
              >
                {record?.logs?.success?.length > 0 && (
                  <>
                    <h6 className="ant-dropdown-menu-item log-heading">
                      {intl.formatMessage({ id: 'dtcs.mappings.success' })}
                    </h6>
                    {record?.logs?.success?.map((log, i) => (
                      <p key={i} className="ant-dropdown-menu-item log-body">
                        {log}
                      </p>
                    ))}
                  </>
                )}

                {record?.logs?.errors?.length > 0 && (
                  <>
                    <Divider size="small" />
                    <h6 className="ant-dropdown-menu-item log-heading">
                      {intl.formatMessage({ id: 'dtcs.mappings.errors' })}
                    </h6>
                    {record.logs.errors.map((log, i) => (
                      <p key={i} className="ant-dropdown-menu-item log-body">
                        {log}
                      </p>
                    ))}
                  </>
                )}
              </div>
            )}
          >
            <Button type="link" className="link-button">
              {intl.formatMessage({ id: 'dtcs.tracerMapping.logs' })}
            </Button>
          </Dropdown>
        ) : (
          <Button
            type="link"
            className="link-button"
            onClick={() => onAccept('accept', index, record)}
          >
            {intl.formatMessage({ id: 'dtcs.tracerMapping.accept' })}
          </Button>
        )}
      </Flex>

      <Flex className="review-body">
        <Mappings title={intl.formatMessage({ id: 'generic.start' })} mappings={record?.at_mapping?.start} />
        <Mappings title={intl.formatMessage({ id: 'generic.end' })} mappings={record?.at_mapping?.end} />
        <Mappings title={intl.formatMessage({ id: 'generic.devices' })} mappings={record?.at_mapping?.devices} />
      </Flex>

      <Flex className="review-body">
        {record.tracer_mappings.map((mapping, mappingIndex) => {
          return (
            <React.Fragment key={`tracer-mapping-${mappingIndex}`}>
              <Mappings
                title={intl.formatMessage({ id: 'generic.start' })}
                mappings={mapping?.start ? [mapping?.start] : []}
              />
              <Mappings
                title={intl.formatMessage({ id: 'generic.end' })}
                mappings={mapping?.end ? [mapping?.end] : []}
              />
              <Mappings
                title={intl.formatMessage({ id: 'generic.devices' })}
                mappings={record?.tracer_mapping?.devices}
                isOneLine={true}
              />
            </React.Fragment>
          )
        })}
      </Flex>
    </div>
  )
}

export default ExpandedRowRender
